import React from "react";
import _ from "lodash";
import moment from "moment";
import Img from "react-image";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import DateFnsUtils from "@date-io/moment";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { connect } from "react-redux";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import {
  postAbsenceSimple,
  updateAbsenceEvent,
  deleteAbsenceEvent,
} from "../les-tabs-ducks/Absence.ducks";
import { withTranslation } from 'react-i18next';
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}

class Absence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textarea: "",
      startDate: (props.dateStartEnd ? moment(props.dateStartEnd.start) : moment())
        .set("hours", 0)
        .set("minutes", 0),
      endDate: (props.dateStartEnd ? moment(props.dateStartEnd.end) : moment())
        .set("hours", 23)
        .set("minutes", 59),
      initialized: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeDateStart = this.handleChangeDateStart.bind(this);
    this.handleChangeDateEnd = this.handleChangeDateEnd.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }

  renderInput = (props) => (
    <div className="col-md-6 col-lg-5">
      <div className="container-select">
        <span>{props.textLabel}</span>
        <input
          readOnly
          className="custom-select-absence box-shadow"
          type="text"
          onClick={props.onClick}
          id={props.id}
          value={props.value}
          {...props.inputProps}
        />
      </div>
    </div>
  );

  getEventDataFromId = (events, id) => {
    return events.find(event => event.id == id)
  }

  componentWillUpdate(prevProps) {
    if (!_.isEmpty(this.props.objAbsence) && !this.state.initialized) {
      let startDate = moment
        .utc(this.props.objAbsence.start)
        .format("ddd DD MMM HH[h]mm");
      let endDate = moment
        .utc(this.props.objAbsence.end)
        .format("ddd DD MMM HH[h]mm");
      let textarea = this.getEventDataFromId(this.props.objAbsence.events, this.props.objAbsence.id).title

      this.setState({
        startDate: startDate,
        endDate: endDate,
        textarea: textarea,
        initialized: true,
      });
    }
  }
  componentDidMount() {
    this.props.handleReadySubmit();
  }

  handleChangeDateStart = (date) => {
    this.setState(
      {
        startDate: date,
      },
      () => {
        if (notEmpty(this.state.endDate) && !this.props.readySubmit) {
          this.props.handleReadySubmit();
        }
      }
    );
  };

  handleChangeDateEnd = (date) => {
    this.setState(
      {
        endDate: date,
      },
      () => {
        if (notEmpty(this.state.startDate) && !this.props.readySubmit) {
          this.props.handleReadySubmit();
        }
      }
    );
  };

  handleChange = (event) => {
    let name = event.target.id;
    this.setState({ [name]: event.target.value });
  };

  handleSubmit(event) {
    event.preventDefault();
    if (
      this.props.isUpdate &&
      this.props.readySubmit &&
      notEmpty(this.state.startDate) &&
      notEmpty(this.state.endDate)
    ) {
      this.props.handleClose();
      console.log('closed')
    } else if (
      this.props.readySubmit &&
      notEmpty(this.state.startDate) &&
      notEmpty(this.state.endDate)
    ) {
      let data = {};
      if (!_.isEmpty(this.state.textarea)) {
        let dataAbsenceEmpty = {
          commentaire: this.state.textarea,
          debut: moment(this.state.startDate).format(),
          fin: moment(this.state.endDate).format(),
        };
        data = dataAbsenceEmpty;
      } else {
        let dataAbsence = {
          commentaire: "Absence",
          debut: moment(this.state.startDate).format(),
          fin: moment(this.state.endDate).format(),
        };
        data = dataAbsence;
      }
      this.props.postAbsenceSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
      this.props.handleSubmit();
    }
  }

  handleStyle() {
    return notEmpty(this.state.startDate) && notEmpty(this.state.endDate)
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }
  handleEventDelete(event) {
    event.preventDefault();
    this.props.deleteAbsenceEvent(
      localStorage.getItem("token"),
      this.props.objAbsence.id,
      this.props.kidItem.id
    );
  }
  render() {
    const { t } = this.props;
    return (
      <div
        className="tab-pane show active"
        id="absence-pane"
        role="tabpanel"
        aria-labelledby="absence-tab"
      >
        <div className="content">
          <form>
            <h2>{t('modal_enfant.absence_tab.duration')}</h2>
            <div className="row d-flex align-items-center justify-content-center mt-3">
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DateTimePicker
                    autoOk
                    ampm={false}
                    value={moment(this.state.startDate, "ddd DD MMM HH[h]mm")}
                    onChange={this.handleChangeDateStart}
                    format={"ddd DD MMM HH[h]mm"}
                    minutesStep={5}
                    TextFieldComponent={this.renderInput}
                    textLabel={t('modal_enfant.absence_tab.from')}
                    disabled={this.state.initialized}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>

              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  className="custom-select box-shadow"
                  utils={DateFnsUtils}
                >
                  <DateTimePicker
                    autoOk
                    ampm={false}
                    value={moment(this.state.endDate, "ddd DD MMM HH[h]mm")}
                    onChange={this.handleChangeDateEnd}
                    format={"ddd DD MMM HH[h]mm"}
                    minutesStep={5}
                    TextFieldComponent={this.renderInput}
                    textLabel={t('modal_enfant.absence_tab.to')}
                    disabled={this.state.initialized}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </div>
            <h2 className="mt-4">
              {t('modal_enfant.absence_tab.observations')} <span>{t('modal_enfant.absence_tab.optional')}</span>
            </h2>
            <div className="row justify-content-center">
              <div className="container-message mt-3 col-md-10">
                <textarea
                  id="textarea"
                  className="box-shadow"
                  onChange={this.handleChange}
                  value={this.state.textarea}
                ></textarea>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-2">
              {this.props.isUpdate ? (
                <button
                  onClick={this.handleEventDelete}
                  className="btn-supprimer"
                >
                  {t('common.delete')}
                </button>
              ) : (
                ""
              )}
              <button
                type="submit"
                className="btn-gradient btn-valid md-5"
                onClick={this.handleSubmit}
                style={this.handleStyle()}
              >
                <IconCheckWhite className="img-fluid" />
                {t('common.validate')}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  postAbsenceSimple,
  updateAbsenceEvent,
  deleteAbsenceEvent,
})(withTranslation()(Absence));
